import type { CaseStudy } from '@/mocks/realisations';

type CaseCardProps = {
  study: CaseStudy;
  onOpen: () => void;
};

export default function CaseCard({ study, onOpen }: CaseCardProps) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="group flex h-full w-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left transition-colors duration-300 hover:border-primary-300"
    >
      <div className="card-img-zoom relative aspect-[4/3] w-full overflow-hidden bg-background-200">
        <img
          src={study.image}
          alt={study.title}
          title={`${study.title} — réalisation SGSCTIC`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
        <span className="absolute left-4 top-4 rounded-sm bg-background-50/95 px-2.5 py-1 font-label text-[10px] uppercase tracking-[0.16em] text-foreground-900">
          {study.sector}
        </span>
        <span className="absolute right-4 top-4 font-label text-[10px] uppercase tracking-[0.2em] text-background-50">
          {study.year}
        </span>
        <span className="absolute bottom-4 left-4 font-label text-[10px] uppercase tracking-[0.16em] text-background-100">
          {study.lead}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-5 md:p-6">
        <span
          role="heading"
          aria-level={3}
          className="block font-heading text-2xl font-semibold uppercase leading-tight text-foreground-950"
        >
          {study.title}
        </span>
        <p className="mt-2 text-xs uppercase tracking-[0.12em] text-foreground-500">
          {study.scope}
        </p>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{study.summary}</p>
        <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary-600">
          Lire l’étude de cas
          <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </button>
  );
}